import ExportTableXlsxFile from './ExportTableXlsxFile';

export default ExportTableXlsxFile;
